/*
drop_items.js
下拉菜单的选项
 */

import React from 'react';
import {DeleteOutlined, EditOutlined} from '@ant-design/icons';

export const dropdown_items = [
    {
        key: '1',
        icon: <EditOutlined/>,
        label: '重命名',
    },
    {
        key: '2',
        icon: <DeleteOutlined/>,
        label: '删除会话',
        danger: true,
    },
];